import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { OverviewComponent } from './overview/overview.component';
import { BookingsComponent } from './overview/bookings/bookings.component';
import { PriceDataComponent } from './overview/price-data/price-data.component';
import { SharedModule } from '../../../shared/shared/shared.module';
import { HousingRequestsComponent } from './overview/housing-requests/housing-requests.component';
import { ModalPriceCrawlerCreationComponent } from './overview/modal-price-crawler-creation/modal-price-crawler-creation.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PriceCrawlerJobsComponent } from './overview/price-crawler-jobs/price-crawler-jobs.component';
import { ChannelmanagerComponent } from './channelmanager/channelmanager.component';
import { PreOffersComponent } from './overview/preoffers/preoffers.component';
import { OffersComponent } from './overview/offers/offers.component';
import { NoOffersComponent } from './overview/no-offers/no-offers.component';
import { HousingAvailabilityComponent } from './overview/housing-availability/housing-availability.component';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  declarations: [
    OverviewComponent,
    ModalPriceCrawlerCreationComponent,
    HousingRequestsComponent,
    BookingsComponent,
    PriceCrawlerJobsComponent,
    PriceDataComponent,
    PreOffersComponent,
    OffersComponent,
    NoOffersComponent,
    ChannelmanagerComponent,
    HousingAvailabilityComponent,
  ],
})
export class HousingInfoModule {}
